import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface DisqualificationReason {
  reason: string;
  details: string;
}

interface DisqualificationReasonsProps {
  reasons: DisqualificationReason[];
}

export default function DisqualificationReasons({ reasons }: DisqualificationReasonsProps) {
  return (
    <div className="bg-red-50 rounded-xl p-8 mt-12">
      <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
        <AlertTriangle className="h-6 w-6 text-red-500 mr-3" />
        Motivos de Descalificación
      </h2>
      <div className="space-y-4">
        {reasons.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
          >
            <h3 className="font-semibold text-red-600 mb-2 flex items-center">
              <AlertTriangle className="h-4 w-4 mr-2" />
              {item.reason}
            </h3>
            <p className="text-gray-600 text-sm">{item.details}</p>
          </div>
        ))}
      </div>
    </div>
  );
}